module.exports = __webpack_public_path__ + "media/images/Bathroom Cabinets-76d612fb.webp";